import { render, staticRenderFns } from "./NewBrand.vue?vue&type=template&id=fd29b1d8&scoped=true&"
import script from "./NewBrand.vue?vue&type=script&lang=js&"
export * from "./NewBrand.vue?vue&type=script&lang=js&"
import style0 from "./NewBrand.vue?vue&type=style&index=0&id=fd29b1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd29b1d8",
  null
  
)

export default component.exports